import { render, staticRenderFns } from "./BriefForm.vue?vue&type=template&id=79e07ebf&scoped=true&"
import script from "./BriefForm.vue?vue&type=script&lang=js&"
export * from "./BriefForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e07ebf",
  null
  
)

export default component.exports